import { copyString } from "./copyString";

type ObjectKey = keyof typeof copyString;

export const t = (id: string) => {
  return copyString?.[id as ObjectKey] ?? "";
};
